import { useFiltersV2Actions, useFiltersV2Store } from "PFApp/components/filters_v2";
import { areBufferedChildrenFiltersOnSelector } from "PFApp/components/filters_v2/stores/filters_v2_store/filters_v2_store_selectors";
import { Inline } from "PFComponents/containers";
import Toggle from "PFComponents/toggle/toggle";
import { TooltipIcon } from "PFComponents/tooltip";
import React from "react";

export type FiltersV2ChildrenToggleProps = {
  title: string;
  info: string;
};

export const FiltersV2ChildrenToggle = ({ title, info }: FiltersV2ChildrenToggleProps) => {
  const { toggleChildrenFiltersInBuffer } = useFiltersV2Actions();
  const areChildrenOn = useFiltersV2Store(areBufferedChildrenFiltersOnSelector);

  return (
    <Inline alignItems="center">
      <Toggle title={title} checked={areChildrenOn} onChange={toggleChildrenFiltersInBuffer} />
      <TooltipIcon content={info} />
    </Inline>
  );
};
